import React from "react";
import { connect } from "react-redux";
import CardGroup from "react-bootstrap/CardGroup";

import SummaryCard from "./SummaryCard";

const Summary = props => {
  // console.log(props.agents.timestamp)
  const agentsAuxCount = props.agents.agents_aux_list.length;
  const agentsUnavailableCount = props.agents.agents_unavailable_list.length;

  const agentsTotalCount =
    props.agents.agents_available_list_in.length +
    props.agents.agents_available_list_out.length +
    props.agents.agents_aux_list.length;
  const agentsInCount = `${props.agents.agents_talking_in}/${props.agents.agents_free_in}`;
  const agentsOutCount = `${props.agents.agents_talking_out}/${props.agents.agents_free_out}`;
  const callsWaitingCount = props.queues.callers_in_queues.filter(
    entry => entry.status === "InQueue"
  ).length;
  const callsRingingCount = props.queues.callers_in_queues.filter(
    entry => entry.status === "Ringing"
  ).length;

  return (
    <div className="border rounded p-1">
      <CardGroup>
        <SummaryCard
          icon="bi-people-fill"
          bodyText="Total Agents"
          value={agentsTotalCount}
          footerText="Total agents (IN + OUT)"
        />
        <SummaryCard
          icon="bi-people-fill"
          bodyText="Talking/Free (IN)"
          value={agentsInCount}
          footerText="Talking/Free agents - IN"
        />
        <SummaryCard
          icon="bi-people-fill"
          bodyText="Talking/Free (OUT)"
          value={agentsOutCount}
          footerText="Talking/Free agents - OUT"
        />
        <SummaryCard
          icon="bi-people"
          bodyText="Agents - AUX"
          value={agentsAuxCount}
          footerText="Number of agents - AUX"
        />
      </CardGroup>

      <CardGroup>
        <SummaryCard
          icon="bi-x-octagon"
          bodyText="Agents - Unavailable"
          value={agentsUnavailableCount}
          footerText="Number of unavailable agents"
        />
        <SummaryCard
          icon="bi-telephone-inbound"
          bodyText="Calls - Waiting"
          value={callsWaitingCount}
          footerText="Calls in waiting status"
        />
        <SummaryCard
          icon="bi-telephone-inbound"
          bodyText="Calls - Ringing"
          value={callsRingingCount}
          footerText="Calls in ringing status"
        />
        <SummaryCard
          icon="bi-telephone-x"
          bodyText="Abandoned Calls"
          value={props.queue_stats.abandoned_count}
          footerText="Number of abandoned calls"
        />
      </CardGroup>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    agents: state.rmqReducer.agents,
    queue_stats: state.rmqReducer.queue_stats,
    queues: state.rmqReducer.queues,
  };
};

export default connect(mapStateToProps)(Summary);
